import React, { useRef, useEffect } from 'react';

const WaveCanvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = 500;
    };

    window.addEventListener('resize', resize);
    resize();

    const render = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // --- COLOR CHANGE LOGIC START ---
      const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      gradient.addColorStop(0, '#01386A');
      gradient.addColorStop(1, '#01386A');
      
      ctx.strokeStyle = gradient; 
      ctx.lineWidth = 0.69; 
      // --- COLOR CHANGE LOGIC END ---

      const time = Date.now() * 0.0005;
      for (let j = 0; j < 8; j++) {
        ctx.beginPath();
        // Har line ki opacity thodi vary karne ke liye
        ctx.globalAlpha = 0.4 + (j * 0.05); 
        
        for (let i = 0; i <= canvas.width; i += 10) {
          // Changed 100 to 250 to vertically center the wave inside the 500px canvas
          // Increased amplitude from 30 to 50 for a slightly better diagonal flow
          const y = 250 + Math.sin(i * 0.003 + time + j * 0.3) * 50;
          if (i === 0) ctx.moveTo(i, y);
          else ctx.lineTo(i, y);
        }
        ctx.stroke();
      }
      animationFrameId = requestAnimationFrame(render);
    };

    render();
    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas 
      ref={canvasRef} 
      // Centered position, larger width to prevent edge cutoff, and a nice 25-degree diagonal tilt
      className="absolute top-1/2 left-1/2 w-[150%] h-[500px] pointer-events-none -translate-x-1/2 -translate-y-1/2 -rotate-[25deg]" 
      style={{ mixBlendMode: 'screen' }} 
    />
  );
};

export default WaveCanvas;